import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useId } from 'react';

import { OptionVariationData } from '../../../../../data/model';
import { FabricFacetFiltersTranslation } from '../../../../../localization/SiteTranslation';
import FacetFilterDropdown from '../FacetFilterDropdown/FacetFilterDropdown';
import css from './ColorFacetFilter.css';
import ColorFacetFilterState from './ColorFacetFilterState';

interface ColorFacetFilterProps {
  state: ColorFacetFilterState;
  translation: FabricFacetFiltersTranslation;
  className?: string;
  allItems: Array<OptionVariationData>;
}

const ColorFacetFilter = ({ className, state, translation, allItems }: ColorFacetFilterProps) => {
  if (state.availableProperties.length === 0) {
    return null;
  }

  return (
    <FacetFilterDropdown className={className} label={translation.colorFilterLabel} count={state.selectedCount}>
      <div className={css.items}>
        {state.availableProperties.map((item) => (
          <Option item={item} key={item.data.valueId} allItems={allItems} />
        ))}
      </div>
    </FacetFilterDropdown>
  );
};

export default observer(ColorFacetFilter);

type ColorOptionItem = ColorFacetFilterState['availableProperties'][number];

interface ColorOptionProps {
  item: ColorOptionItem;
  allItems: Array<OptionVariationData>;
}

const Option = observer(({ item, allItems }: ColorOptionProps) => {
  const id = useId();

  const availableResultsCount = item.countAvailableResults(allItems);
  const disabled = availableResultsCount === 0;

  return (
    <div className={css.item}>
      <label className={classNames(css.label, { [css.disabled]: disabled })} htmlFor={id}>
        <span className={css.color}>
          <span className={css.colorInner} style={{ backgroundColor: item.data.hexColor }} />
        </span>
        <span>
          {item.data.value} <span className={css.count}>({availableResultsCount})</span>
        </span>
      </label>
      <input
        type="checkbox"
        id={id}
        className={css.checkbox}
        name={item.data.name}
        value={item.data.value}
        checked={item.selected}
        disabled={disabled}
        onChange={() => item.toggle()}
      />
    </div>
  );
});
